import dynamic from 'next/dynamic';
import styled from 'styled-components';
import {useTranslation} from 'next-i18next';
import DrawnArrow from '../../../public/images/drawnArrow.svg';
import {panelistaPrimaryColor} from 'src/utils/constants';
import {Container} from '../landing/LandingHeroSection';
import {HandWriting} from '../landingStyledComponents';
import RealWidget from '../touchpoints/RealWidget';
import {WidthContainer} from './LandingComponents';

const ReactPlayer = dynamic(() => import('react-player/file'), {ssr: false});

const compactThreshold = 900;
const mobileThreshold = 600;

const DataProtectionContainer = styled(Container)`
  height: initial;
  max-height: initial;
  min-height: initial;
`;

const StyledWidthContainer = styled(WidthContainer)`
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  padding-bottom: 20px;
  align-items: center;

  @media (max-width: ${compactThreshold}px) {
    padding: 0 var(--side-padding);
    margin-top: 40px;
  }

  @media (max-height: 800px) {
    margin-top: 40px;
  }

  .data-protection-strip {
    @media (max-width: 1000px) {
      margin: 50px auto;
    }

    @media (max-width: 900px) {
      margin: 30px auto;
    }

    @media (max-width: 700px) {
      margin: 10px auto 70px auto;
    }
  }
`;

const VideoContainer = styled.div`
  background-color: white;
  border-radius: 24px;
  width: 100%;
  max-width: 1170px;
  flex-grow: 1;
  z-index: 1;
  box-shadow: 0px 14px 54px 0 rgba(21, 134, 140, 0.2);
  margin-bottom: 100px;
  position: relative;
  overflow: hidden;

  @media (max-width: ${compactThreshold}px) {
    margin-top: 0;
  }

  @media (max-width: ${mobileThreshold}px) {
    margin: 0 0 50px 0;
  }
`;

const AspectRatioWrapper = styled.div`
  width: 100%;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
`;

const PlayerAndStripContainer = styled.div`
  width: 100%;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 700px) {
    flex-direction: column-reverse;
  }
`;

const StyledDrawnArrow = styled(DrawnArrow)`
  position: absolute;
  top: -20px;
  right: -40px;
  transform: rotate(30deg);

  @media (max-width: 700px) {
    display: none;
  }
`;

const StyledHandwriting = styled(HandWriting)`
  position: absolute;
  top: -60px;
  right: -100px;
  transform: rotate(-6deg);
  color: ${panelistaPrimaryColor};

  @media (max-width: 700px) {
    display: none;
  }
`;

const WidgetContainer = styled.div`
  margin-top: 50px;
  position: relative;
  width: 100%;
  max-width: 400px;
  display: flex;
  justify-content: center;
`;

const videoIds = {
  sv: 'eg4I3Dvh8F',
  en: 'giKpc2rhKD'
};

const touchpointIds = {
  sv: '620f5cd2fc13dc001677e951',
  en: '6284e37d2940af00168367c3'
};

const VideoDemoContent = () => {
  const {t, i18n} = useTranslation();

  return (
    <DataProtectionContainer>
      <StyledWidthContainer>
        <PlayerAndStripContainer>
          <VideoContainer>
            <AspectRatioWrapper>
              <ReactPlayer
                url={`https://panelista.s3.nl-ams.scw.cloud/website/${videoIds[i18n.language]}/playlist.m3u8`}
                height="101%"
                width="101%"
                playsinline
                style={{position: 'absolute', top: '-0.5%', left: '-0.5%'}}
                controls
                onPlay={() => plausible('Demo video played')}
                config={{
                  attributes: {
                    poster: 'https://panelista.s3.nl-ams.scw.cloud/website/video_preview.jpg'
                  }
                }}
              />
            </AspectRatioWrapper>
          </VideoContainer>
        </PlayerAndStripContainer>

        <WidgetContainer>
          <RealWidget touchpointId={touchpointIds[i18n.language]} />

          <StyledDrawnArrow />
          <StyledHandwriting>{t('website.try it out')}</StyledHandwriting>
        </WidgetContainer>
      </StyledWidthContainer>
    </DataProtectionContainer>
  );
};

export default VideoDemoContent;
